<canvas baseChart [data]="pieChartData" [type]="pieChartType" [options]="chartOptions" width="350"></canvas>
